import { ReactNode } from "react"

import { AgentRunnerHistoryPanel } from "@components/panels/agent-runner/AgentRunnerHistoryPanel"

interface AgentRunnerOverlayPanelProps {
    children?: ReactNode
}
export function AgentRunnerOverlayPanel({ children }: Readonly<AgentRunnerOverlayPanelProps>) {
    return (
        <div className="h-full">
            <div className="w-full flex flex-row gap-2 items-center justify-between p-2">
                <span className="text-lg font-semibold">History</span>
                {children}
            </div>
            <div className="h-full overflow-auto">
                <AgentRunnerHistoryPanel />
            </div>
        </div>
    )
}
